import Swal, { type SweetAlertOptions } from "sweetalert2";

/** Resolves a snake_case or i18n key to a human-readable string. */
export const resolveMessage = (
  t: (key: string) => string,
  message?: string,
  fallback = "Something went wrong",
): string => {
  if (!message) return fallback;
  const translated = t(message);
  if (translated && translated !== message) return translated;
  if (translated?.trim()) return translated;
  return message.includes("_")
    ? message.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : message;
};

/** Extracts a message from an Axios-style error object. */
export const getErrorMessage = (
  t: (key: string) => string,
  error: unknown,
): string => {
  const msg = (error as { response?: { data?: { message?: string } } })
    ?.response?.data?.message;
  return resolveMessage(t, msg);
};

/** Fires a Sweetalert2 toast. */
export const fireToast = (
  t: (key: string) => string,
  settings: Partial<SweetAlertOptions>,
  icon: SweetAlertOptions["icon"],
  message?: string,
): void => {
  void Swal.fire({
    ...settings,
    icon,
    text: resolveMessage(t, message),
  } as SweetAlertOptions);
};

/** Validates a gift-card / money input value, returns an i18n error key or empty string. */
export const getGiftCardInlineError = (
  t: (key: string) => string,
  rawValue: string | number | undefined | null,
): string => {
  const normalized = String(rawValue ?? "").trim();
  if (!normalized) return "";
  if (!/^\d+$/.test(normalized)) return t("label_amount_integer_error");
  if (Number(normalized) < 1) return t("number_err_msg");
  return "";
};
